<template>
  <div ref="componentSection">
    <div class="mx-4" :id="'main-div'+index" v-if="content == ''">
      <v-layout row wrap>
        <v-flex xs12 md4 class="mx-4 my-2">
          <ChangeImage />
        </v-flex>
        <v-flex xs12 md7 class="my-2">
          <v-alert
            :color="getThemeColor"
            border="left"
            elevation="12"
            icon="mdi-school"
            contenteditable
            class="teal darken-4"
          >
            <h1
              class="h1 text-center text-decoration-underline"
              style="color:white"
            >Paragraph Component</h1>
            <div
              class="h2 font-weight-light"
              style="color:white"
            >Maecenas ullamcorper, pulvinar rutrum, ipsum laoreet sapien, quis venenatis ante odio sit amet eros.</div>
          </v-alert>
        </v-flex>
      </v-layout>
    </div>
    <div v-else v-html="content"></div>
  </div>
</template>

<script>
import ChangeImage from "./ChangeImage.vue";

export default {
  props: ["index", "header", "del", "content"],
  mounted() {
    this.attachEventListeners();
  },
  updated() {
    this.attachEventListeners();
  },

  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getComponents() {
      return this.$store.getters.getComponents;
    }
  },
  components: { ChangeImage },
  methods: {
    updateComponent() {
      const componentSection = this.$refs.componentSection;
      this.$store.commit("updateStoreComponent", {
        index: this.index,
        componentSection: componentSection.innerHTML
      });
    },

    attachEventListeners() {
      const mainDiv = document.getElementById("main-div" + this.index);
      mainDiv.addEventListener("focusout", () => {
        this.updateComponent();
      });
    }
  }
};
</script>

<style>
</style>